module.exports = __webpack_public_path__ + "img/icon_time.b0f778df.svg";